// ──────────────────────────────────────────────────────────────────────────
// NOMI CHE STANNO IN RIGA
//
// Una fila di pastiglie con i nomi va a capo dove capita: due nomi lunghi
// finiscono uno per riga, e lo spazio accanto resta vuoto. Accorciando il
// nome di battesimo — "Fab. Arvieri" — spesso ci stanno tutti e due. Si
// accorcia solo quando serve: un nome che sta intero resta intero.
// ──────────────────────────────────────────────────────────────────────────

// "Fabrizio Arvieri" → "Fab. Arvieri". Un nome corto, o un nome solo, resta
// com'è: "Ugo Neri" accorciato non guadagna niente, e "Bibo" non ha un
// cognome da tenere.
export const shortPlayerName = name => {
	const tokens = (name ?? "").trim().split(/\s+/)
	if (tokens.length < 2 || tokens[0].length <= 4) return (name ?? "").trim()
	return [`${tokens[0].slice(0, 3)}.`, ...tokens.slice(1)].join(" ")
}

// Quali pastiglie accorciare perché la fila vada a capo il meno possibile.
// `widths` sono le larghezze di ogni pastiglia intera e accorciata, nello
// stesso ordine in cui stanno in fila; la risposta dice, per ognuna, se va
// accorciata.
//
// Si riempie una riga alla volta. Chi non sta intero prova accorciato; se
// ancora non sta si accorciano anche quelli già in riga, dall'ultimo, finché
// ci sta. Se nemmeno così ci sta, va a capo — intero, come chi lo precede,
// perché a capo la riga è di nuovo vuota.
export const fitLabels = (widths, rowWidth, gap = 0) => {
	const short = widths.map(() => false)
	let row = []
	let used = 0

	const widthOf = i => (short[i] ? widths[i].short : widths[i].full)

	widths.forEach(({ full, short: shortWidth }, i) => {
		const add = row.length > 0 ? gap : 0

		if (used + add + full <= rowWidth) {
			row.push(i)
			used += add + full
			return
		}

		if (row.length > 0) {
			// si prova ad accorciare lui, e poi chi c'è già in riga
			const shortened = [i]
			short[i] = true
			let trial = used + add + shortWidth

			for (let k = row.length - 1; k >= 0 && trial > rowWidth; k--) {
				const j = row[k]
				if (short[j]) continue
				short[j] = true
				shortened.push(j)
				trial -= widths[j].full - widths[j].short
			}

			if (trial <= rowWidth) {
				row.push(i)
				used = trial
				return
			}

			// non ci sta comunque: tutto com'era, e si va a capo
			shortened.forEach(j => {
				short[j] = false
			})
		}

		// una riga nuova: intero se ci sta, accorciato se nemmeno da solo
		short[i] = full > rowWidth
		row = [i]
		used = widthOf(i)
	})

	return short
}
